import { X } from 'lucide-react';
import i18n from '@/settings/i18n';
import { HeaderProps } from './types';

const t = i18n.init('product');

const Header = ({ setShowModal }: HeaderProps) => (
  <div className="sticky top-0 z-[70] flex items-center justify-between bg-white px-6 py-4 shadow">
    <h3 className="font-medium">{t`About this seller`}</h3>
    <button
      onClick={() => setShowModal(false)}
      className="transition duration-150 ease-in-out hover:scale-110 focus:outline-none"
    >
      <X className="h-5 w-5" />
    </button>
  </div>
);

export default Header;
